import SettingsTableColumnRender from './SettingsTableColumnRender'

export default SettingsTableColumnRender
